<template>
  <div class="cruise-card-footer tw-flex tw-flex-2 sm:tw-flex-3 tw-flex-nowrap tw-w-full tw-justify-between tw-px-4 sm:tw-px-20">
    <!-- remove sm:tw-hidden when "From" gets added back -->
    <div class="cruise-card-footer__price tw-flex tw-flex-col tw-justify-center sm:tw-hidden">
      <div class="tw-flex tw-justify-center">
        <!--        <span class="cruise-card-footer__price__amount__label tw-mr-1.5 tw-flex tw-justify-center">-->
        <!--          {{ fromLabel }}-->
        <!--        </span>-->
        <!--        <span class="cruise-card-footer__price__amount__old-price tw-mr-2 tw-flex tw-flex-col tw-justify-end">-->
        <!--          {{ getStartPrice }}-->
        <!--        </span>-->
      </div>
      <div class="tw-flex tw-justify-center sm:tw-hidden">
        <span class="cruise-card-footer__price__amount__current-price">{{ getPrice }}</span>
        <span class="cruise-card-footer__price__amount__price-type tw-pl-2 tw-mb-1 tw-flex tw-flex-col tw-justify-end">
          {{ getPriceTypeLabel }}
        </span>
      </div>
      <div v-if="isUpliftEnabled" class="cruise-card-footer__price__deposit tw-flex tw-justify-center">
        <span class="cruise-card-footer__price__deposit__label tw-pr-1">{{ upliftFromLabel }}</span>
        <span class="cruise-card-footer__price__deposit__price">{{ getUpliftPrice }}</span>
        <svg class="tw-mt-1.5 tw-ml-0.5" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M3.99996 7.33334C2.15996 7.33334 0.666626 5.84001 0.666626 4.00001C0.666626 2.16001 2.15996 0.666677 3.99996 0.666677C5.83996 0.666677 7.33329 2.16001 7.33329 4.00001C7.33329 5.84001 5.83996 7.33334 3.99996 7.33334ZM4.33329 2.33334H3.66663V3.00001H4.33329V2.33334ZM4.33329 3.66668H3.66663V5.66668H4.33329V3.66668Z"
            fill="#FF690E"/>
        </svg>
      </div>
    </div>
    <div class="cruise-card-footer__price-middle tw-hidden sm:tw-flex tw-flex-grow">
      <span class="cruise-card-footer__price-middle__current-price">{{ getPrice }}</span>
      <span class="cruise-card-footer__price-middle__price-type tw-pl-2 tw-mt-2.5 tw-flex tw-flex-col tw-justify-end">
        {{ getPriceTypeLabel }}
      </span>
    </div>
    <div class="cruise-card-footer__submit-btn tw-flex tw-flex-col tw-justify-center" @click="goToBooking">
      <Button :label="bookNowLabel" :primary="true" :square="true"/>
    </div>
  </div>
</template>

<script>
import Button from "@/stories/Atoms/Button/Button";

export default {
  name: "CruiseCardFooter",
  components: {
    Button
  },
  props: {
    demoMode: {
      type: Boolean,
      required: false,
      default: false
    },
    labels: {
      type: Object,
      default: () => {
      }
    },
    startPrice: {
      type: Number,
      require: false,
      default: 745
    },
    price: {
      type: Number,
      require: false,
      default: 538
    },
    upliftPrice: {
      type: Number,
      required: false,
      default: 14.17
    },
    isUpliftEnabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    bookNowLabel() {
      return this.labels?.cruiseCardSubmitButtonLabel
    },
    fromLabel() {
      return this.labels?.cruiseCardPriceFromLabel || 'From'
    },
    currencyLabel() {
      return this.labels?.cruiseCardCurrencyLabel || '$'
    },
    getPriceTypeLabel() {
      return this.labels?.cruiseCardPriceType || 'pp*'
    },
    upliftFromLabel() {
      return this.labels?.cruiseCardMobileFooterFromDepositLabel || 'or from'
    },
    upliftMonthLabel() {
      return this.labels?.cruiseCardMobileFooterRangeDepositLabel || 'month'
    },
    getStartPrice() {
      return `${this.currencyLabel} ${this.startPrice}`
    },
    getPrice() {
      return `${this.currencyLabel} ${this.price}`
    },
    getUpliftPrice() {
      return `${this.currencyLabel}${this.upliftPrice}/${this.upliftMonthLabel}`
    }
  },
  methods: {
    goToBooking() {
      if (this.demoMode) return
      this.$emit('go-to-booking')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "ItineraryCardFooter";
</style>
